import React from 'react';
import { Link } from 'react-router-dom';
import { useGuideRequest } from './GuideRequestModal';

const SITE_NAME = 'StartEase Agent';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ease-backend/artifacts/4auzvo9b_StartEase%20Logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { open: openGuide } = useGuideRequest();

  return (
    <footer className="bg-[#0b1310] text-white border-t border-white/10" data-testid="site-footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt={SITE_NAME} className="h-8 w-8" />
              <span className="text-lg font-semibold">{SITE_NAME}</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-[280px]">
              <span className="block text-white font-medium">One platform for your US business.</span>
              <span className="mt-1 block">Formation, compliance, payroll, sales tax and bookkeeping — handled in-house by StartEase, end to end.</span>
            </p>
          </div>

          {/* Solutions */}
          <div data-testid="footer-solutions-col">
            <h3 className="font-mono text-emerald-400 mb-4 text-[10.5px] uppercase tracking-[0.2em]">Solutions</h3>
            <ul className="space-y-2">
              <li><Link to="/usa" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-formation">Company Formation</Link></li>
              <li><Link to="/usa/payroll" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-payroll">Managed Payroll</Link></li>
              <li><Link to="/usa/sales-tax" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-sales-tax">Managed Sales Tax</Link></li>
              <li><Link to="/usa/bookkeeping" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-bookkeeping">Managed Bookkeeping</Link></li>
            </ul>
          </div>

          {/* Documents */}
          <div data-testid="footer-documents-col">
            <h3 className="font-mono text-emerald-400 mb-4 text-[10.5px] uppercase tracking-[0.2em]">Documents</h3>
            <ul className="space-y-2">
              <li><Link to="/investment-drafting" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-investment-drafting">Investment Drafting</Link></li>
              <li><Link to="/ai-document-services" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-ai-compliance-packs">AI Compliance Packs</Link></li>
              {/* Rewired to GuideRequest modal (Free Guide Email Capture) */}
              <li>
                <button
                  type="button"
                  onClick={() => openGuide('footer')}
                  className="text-slate-400 hover:text-white text-sm transition-colors bg-transparent p-0 border-0 text-left cursor-pointer"
                  data-testid="footer-risk-check"
                >
                  Free Domain Risk Check
                </button>
              </li>
              <li><Link to="/ai-law-watch" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-law-watch">Law Watch</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div data-testid="footer-company-col">
            <h3 className="font-mono text-emerald-400 mb-4 text-[10.5px] uppercase tracking-[0.2em]">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/login" className="text-slate-400 hover:text-white text-sm transition-colors">Client Portal</Link></li>
              <li><Link to="/faq" className="text-slate-400 hover:text-white text-sm transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white text-sm transition-colors">Contact</Link></li>
              <li><Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            © {currentYear} StartEase. All rights reserved.
          </p>
          <span className="font-mono text-slate-500 text-[10.5px] tracking-[0.16em]">STARTEASEAI.COM</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
